import { useContext, useEffect, useRef, useState } from 'react';
import { UserContext } from '../../ContextApi/context';
import { CityContext } from '../../ContextApi/cityContext';
import apiPush from '../../_ApiConn/apiPush';

// רישום המכשיר לקבלת push מה-ADMIN ("שליחת התראה"), רק כשהאתר רץ בתוך האפליקציה ויש token של FCM.
// האפליקציה (מגרסה 1.0.11) נותנת את ה-token ב-localStorage "amPushToken" ({ token, platform }),
// ובאירוע window "amPushToken" (event.detail באותו מבנה) בכל טעינה וכשה-token מתחלף.
// נרשמים מחדש בכל שינוי: token, עיר / מרחב, התחברות והתנתקות (אחרי התנתקות - בלי משתמש).
// בדפדפן רגיל אין token, ולא קורה כלום.

const LS_KEY = 'amPushToken';
const DEBOUNCE = 1500; // בעלייה המשתמש והעיר נטענים בנפרד - בקשה אחת במקום כמה

const validInfo = (v) => (v && typeof v.token === 'string' && v.token && ['android', 'ios'].includes(v.platform))
    ? { token: v.token, platform: v.platform } : null;

const readStored = () => {
    try { return validInfo(JSON.parse(localStorage.getItem(LS_KEY))); } catch (e) { return null; }
};

const PushRegistrar = () => {
    const [user] = useContext(UserContext);
    const { city, myCity } = useContext(CityContext);
    const [info, setInfo] = useState(readStored);
    const lastSent = useRef('');

    useEffect(() => {
        const onToken = (e) => {
            const v = validInfo(e && e.detail);
            if (v) setInfo(v);
        };
        window.addEventListener(LS_KEY, onToken);
        return () => window.removeEventListener(LS_KEY, onToken);
    }, []);

    const userId = (user && user._id) || null;
    const placeId = (city && city._id) || null;
    const myCityId = (myCity && myCity._id) || null;

    useEffect(() => {
        if (!info) return;
        const key = [info.token, info.platform, placeId, myCityId, userId].join('|');
        if (key === lastSent.current) return;
        const t = setTimeout(() => {
            let usrtoken = null;
            try { usrtoken = userId ? localStorage.getItem('usrtoken') : null; } catch (e) { }
            lastSent.current = key;
            apiPush.registerDevice({ token: info.token, platform: info.platform, placeId, myCityId, usrtoken })
                .catch(() => { lastSent.current = ''; });
        }, DEBOUNCE);
        return () => clearTimeout(t);
    }, [info, placeId, myCityId, userId]);

    return null;
};

export default PushRegistrar;
